import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c3d21bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-flex is-justify-content-space-between is-flex-wrap-wrap" }


import VueIFrame from '@/components/IFrame.vue'
import Videos from "@/entities/video";
interface Props {
  videos: Videos[]
}


export default /*#__PURE__*/_defineComponent({
  props: {
    videos: null
  },
  setup(__props: any) {

const props = __props as {
  videos: Videos[]
}




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.videos, (video) => {
      return (_openBlock(), _createBlock(VueIFrame, {
        key: video.id,
        src: video.url,
        class: "iframe-size"
      }, null, 8, ["src"]))
    }), 128))
  ]))
}
}

})